'use client';

import { c as _c } from "react/compiler-runtime";
import OptimizedImage from '@/components/OptimizedImage';
import { CANONICAL_COVER_SRC_WIDTH } from '@/constants/assets';
import { useCheckEnterRoomContext } from '@/context/CheckEnterRoomContext';
import roomDefaultImage from '@/public/images/room-default.png';
import { useTranslations } from 'next-intl';
function WorldThumbnail() {
  const $ = _c(10);
  const t = useTranslations();
  const {
    roomData
  } = useCheckEnterRoomContext();
  const title = roomData.title;
  const ownerName = roomData.owner.display_name;
  let alt = "";
  if (title && ownerName) {
    let t0;
    if ($[0] !== ownerName || $[1] !== t || $[2] !== title) {
      t0 = t("action-world-card-image.alt-with-owner", {
        title,
        owner: ownerName
      });
      $[0] = ownerName;
      $[1] = t;
      $[2] = title;
      $[3] = t0;
    } else {
      t0 = $[3];
    }
    alt = t0;
  } else {
    if (title) {
      let t0;
      if ($[4] !== t || $[5] !== title) {
        t0 = t("action-world-card-image.alt", {
          title
        });
        $[4] = t;
        $[5] = title;
        $[6] = t0;
      } else {
        t0 = $[6];
      }
      alt = t0;
    }
  }
  const t0 = roomData.image || roomDefaultImage.src;
  let t1;
  if ($[7] !== alt || $[8] !== t0) {
    t1 = <div className="relative aspect-video w-[100px] shrink-0 overflow-hidden rounded-[10px] md:w-52"><OptimizedImage src={t0} alt={alt} fill={true} loading="eager" overrideSrcWidth={CANONICAL_COVER_SRC_WIDTH} sizes="(min-width: 768px) min(208px, 100vw), min(100px, 100vw)" className="object-cover" /></div>;
    $[7] = alt;
    $[8] = t0;
    $[9] = t1;
  } else {
    t1 = $[9];
  }
  return t1;
}
export default WorldThumbnail;